export default __webpack_public_path__ + "static/media/angers11.2668f387.jpg";